import styled from "styled-components";

export const ErrorText = styled.span`
  font-size: 12px;
`;
